module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img248-447ad2846482262ad2851303dbd4ada6.jpg";